import * as React from "react";
const SvgFiRrCommentsQuestionCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comments-question-check_svg__a)">
      <path
        fill="#062147"
        d="M14.086 19.414c.392.392.905.586 1.418.586.509 0 1.017-.19 1.399-.575l2.793-2.707a1 1 0 1 0-1.393-1.435l-2.814 2.707-1.674-1.623c2.359-1.509 3.966-3.933 4.162-6.715A9.004 9.004 0 0 0 8.349.023C3.823.343 0 4.59 0 9.296v5.038A3.67 3.67 0 0 0 3.661 18h4.477a10.7 10.7 0 0 0 3.782-.685zM3.661 16A1.665 1.665 0 0 1 2 14.334V9.296C2 5.6 4.972 2.267 8.489 2.018Q8.739 2 8.987 2c1.859 0 3.645.732 4.962 2.051a7.02 7.02 0 0 1 2.033 5.46c-.253 3.578-3.772 6.49-7.845 6.49zm8.292-9.534a3.01 3.01 0 0 1-1.506 3.163C10 9.875 10 9.947 10 10a1 1 0 1 1-2 0c0-1.308 1.038-1.879 1.481-2.123.289-.16.595-.535.502-1.065a1 1 0 0 0-.793-.794.98.98 0 0 0-.832.216A1 1 0 0 0 8 7.001a1 1 0 1 1-2 0A2.996 2.996 0 0 1 9.536 4.05a3.02 3.02 0 0 1 2.417 2.417M10.25 13.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M24 16v5a3 3 0 0 1-3 3h-5c-2.955 0-5.535-1.615-6.92-4.004a11 11 0 0 0 2.242-.248A5.99 5.99 0 0 0 16 22h5a1 1 0 0 0 1-1v-5a5.99 5.99 0 0 0-2.252-4.678c.156-.724.242-1.473.248-2.242C22.385 10.465 24 13.045 24 16"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comments-question-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentsQuestionCheck;
